// List rows (Astryx List and Item, Material item types): records a person
// reads one at a time, such as Insight findings or Action steps. Rows sit
// flush inside a flush Panel, divided by one hairline, top aligned, one
// fixed gap; nothing stretches to fill height.
import type { ReactNode } from "react";

export interface ListRowItem {
  id: string;
  /** 16/500, the row's one lead line. */
  title: ReactNode;
  /** 13 ink-muted, one or two sentences. */
  description?: ReactNode;
  /** A short 13 line under the description: owner, date, source. */
  meta?: ReactNode;
  /** A badge or one small control at the row end (VerdictBadge, Badge). */
  trailing?: ReactNode;
  /** Makes the whole row a link (one list is all links or all static). */
  href?: string;
}

export interface ListRowsProps {
  /** Accessible name of the list. */
  label: string;
  items: ListRowItem[];
}

export function ListRows({ label, items }: ListRowsProps) {
  return (
    <ul className="con-list" aria-label={label}>
      {items.map((item) => {
        const body = (
          <>
            <div className="con-list-text">
              <p className="con-list-title">{item.title}</p>
              {item.description ? <p className="con-list-description">{item.description}</p> : null}
              {item.meta ? <p className="con-list-meta">{item.meta}</p> : null}
            </div>
            {item.trailing ? <div className="con-list-trailing">{item.trailing}</div> : null}
          </>
        );
        return (
          <li key={item.id} className="con-list-item">
            {item.href ? (
              <a className="con-list-row" href={item.href}>
                {body}
              </a>
            ) : (
              <div className="con-list-row">{body}</div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
